import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout";
import Home from "./pages/home/Home";
import ContactUs from "./pages/contact-us/Contact";
import Faqs from "./pages/faqs/Faqs";
import AboutUs from "./pages/about-us/About";
import Products from "./pages/products/Products";
import Services from "./pages/services/Services";
import SliderContext from "./components/sliderContext";
import { useState, useEffect } from "react";
import Gallery from "./pages/gallery/Gallery";
import HostComanPage from "./pages/products/product-pages/hostcoman";

function App() {
  const [sliderOpen, setSliderOpen] = useState(false);
  const [sliderValue, setSliderValue] = useState("");

  useEffect(() => {
    document.body.style.overflow = sliderOpen ? "hidden" : "auto";
  }, [sliderOpen]);

  return (
    <SliderContext.Provider
      value={{ sliderOpen, setSliderOpen, sliderValue, setSliderValue }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
          </Route>
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/products/hostcoman" element={<HostComanPage />} />
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Routes>
      </BrowserRouter>
    </SliderContext.Provider>
  );
}

export default App;
